/* Rquiere de mixin.js */

var address = {
	data () {
		return {
			listAddress: [],
			objectAddress: {
				exists: 0,
				id: 0,
				street: '',
				comuna_id: 0,
				comuna: '',
				longitude: 0,
				latitude: 0,
				postal_code: '',
				transport_id: 0
			},
			methodsAddress: {
				create: 'address/register',
				delete: '/delete',
				get: 'address',
				show: 'address/',
			},
			paginationAddress: [],
			searchAddress: '',
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
		clearObjectAddress() {
			this.objectAddress.exists = 0
			this.objectAddress.id = 0
			this.objectAddress.street = ''
			this.objectAddress.comuna_id = 0
			this.objectAddress.comuna = ''
			this.objectAddress.longitude = 0
			this.objectAddress.latitude = 0
			this.objectAddress.postal_code = ''
			this.objectAddress.transport_id = 0
		},
		deleteAddress(id) {
			let url = this.apiBackend + this.methodsAddress.show + id + this.methodsAddress.delete
			this.axiosActionIS(url, 'DELETE', 'deleteAddressResult')
		},
		deleteAddressResult(response) {
			if(response.data.success == true) {
				this.$snotify.warning('Eliminación exitosa')
			} else {
				this.$snotify.error('No se puedo eliminar la dirección')
			}
			this.deleteAddressResultLocal(response)
		},
		deleteAddressResultLocal(response){
			console.log('deleteAddressResultLocal no desarrollado', response)
		},
		saveAddress(item, controller = '') {
			let method = (item.exists == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')

			let url = (method == 'POST') ? this.apiBackend + controller + this.methodsAddress.create : this.apiBackend + this.methodsAddress.show + '' + item.id
			if(method == 'POST') {
				this.axiosActionIS(url, method, 'saveAddressResult', item)
			} else if(method == 'PUT') {
				this.axiosActionIS(url, method, 'saveAddressResult', item)
			}
		},
		saveAddressResult(response) {
			if(response.data.success == true) {
				if(response.data.message == 'NUEVO') {
					this.$snotify.success('Se guardó correctamente la dirección')
				} else if (response.data.message == 'ACTUALIZADO') {
					this.$snotify.info('Se actualizó correctamente la dirección')
				}
			}
			this.saveAddressResultLocal(response)
		},
		saveAddressResultLocal(response) {
			console.log('saveAddressResultLocal no desarrollado', response)
		}

	},
};

export default address;